@if (loading()) {
<av-spinner size="xs" [mode]="spinnerMode"></av-spinner>
}
<ng-content></ng-content>
